<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <div ref="tableBox" class="activity-table">
      <tableList ref="multipleTable" size="small" :query-function="$Api.taskClock.taskActivityList" style="width: 100%">
        <el-table-column prop="id" label="任务ID" width="150" />

        <el-table-column prop="registrationBeginTime" label="报名日期" width="250">
          <template v-slot="{row}">
            <span> {{ row.registrationBeginTime&& row.registrationEndTime ? $moment(row.registrationBeginTime).format('YYYY/MM/DD') +' - ' +$moment(row.registrationEndTime).format('YYYY/MM/DD') : '--' }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="title" label="任务名称" width="200" />

        <el-table-column prop="status" label="任务状态" width="auto">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="success" size="mini">已发布</el-tag>
            <el-tag v-if="scope.row.status === 1" class="el-tag--yellow" size="mini">草稿</el-tag>
            <el-tag v-if="scope.row.status === 2" class="el-tag--end" size="mini">已结束</el-tag>
            <el-tag v-if="scope.row.status === 3" class="el-tag--gray" size="mini">报名截止</el-tag>
            <el-tag v-if="scope.row.status === 4" class="el-tag--red" size="mini">开发报名中</el-tag>
            <el-tag v-if="scope.row.status === 5" class="el-tag--red" size="mini">未开奖</el-tag>
            <el-tag v-if="scope.row.status === 6" class="el-tag--blue" size="mini">已开奖</el-tag>
            <el-tag v-if="scope.row.status === 7" class="el-tag--purple" size="mini">已公示</el-tag>
            <!-- <el-tag :type="taskStatus[scope.row.status].color" size="mini">{{ taskStatus[scope.row.status].value }}</el-tag> -->
          </template>
        </el-table-column>

        <el-table-column fixed="right" width="430px" label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="text" class="link-color" @click="edit(scope.row)">编辑</el-button>
            <el-button size="small" type="text" class="link-color" @click="copyLink(scope.row.id)">复制链接</el-button>
            <el-button size="small" type="text" class="link-color" @click="remove(scope.row)">删除</el-button>
            <el-button v-if="scope.row.status === 1" size="small" type="text" class="link-color" @click="postOnlineTask(scope.row.id)">发布</el-button>
            <el-button v-if="scope.row.status === 0" size="small" type="text" class="link-color" @click="postOfflineTask(scope.row.id)">下架</el-button>
            <el-button v-if="scope.row.status !== 1" size="small" type="text" class="link-color" @click="downExportList(scope.row.id)">打卡记录</el-button>
            <el-button v-if="scope.row.status === 5" size="small" type="text" class="link-color" @click="runALottery(scope.row)">开奖</el-button>
            <el-button v-if="scope.row.status === 6 || scope.row.status === 7" size="small" type="text" class="link-color" @click="searchResult(scope.row.id)">查看中奖记录</el-button>
            <el-button v-if="scope.row.status === 6 && scope.row.status !== 7" size="small" type="text" class="link-color" @click="showResult(scope.row)">显示中奖公示</el-button>
          </template>
        </el-table-column>
      </tableList>
      <!-- 弹窗 -->
      <el-dialog v-if="importDialogShow" :visible="importDialogShow" title="开奖" custom-class="share-wrapper" @close="handleCloseImport">
        <div class="lottery-top" style="display:flex">
          <div>完成打卡人数：{{ lotteryForm.taskCompleteNum }}</div>
          <div>总奖品数：{{ lotteryForm.prizeNum }}</div>
        </div>
        <div class="lottery-box">
          <el-form ref="lotteryForm" class="lottery-form" :model="lotteryForm" size="small">
            <el-form-item prop="prizeInformationListVOS">
              <template v-for="(item, index) in lotteryForm.prizeInformationListVOS">
                <div :key="index" class="prizeBox">
                  <span>奖品{{ index+1 }}：</span>
                  <span class="prizeName">{{ item.prizeName }}</span>
                  <span>奖品数量：{{ item.prizeNum }}</span>
                </div>
              </template>
            </el-form-item>
            <el-form-item label="有效期" prop="exportTime">
              <el-date-picker v-model="lotteryForm.exportTime" type="datetimerange" range-separator="-" start-placeholder="兑奖开始日期和时间" end-placeholder="兑奖结束日期和时间" class="lottery-time" prefix-icon="el-icon-date" value-format="yyyy-MM-dd HH:mm:ss" @change="handleFormatExportTime" />
            </el-form-item>
          </el-form>
        </div>
        <div class="flex btns">
          <el-button type="info" @click="handleCloseImport">取消</el-button>
          <el-button type="primary" class="submitBtn" @click="uploadSubmit">确认开奖</el-button>
        </div>
      </el-dialog>
      <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSuccess" />
    </div>
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import Dialog from '@/components/Dialog';
import { taskClockExportList } from '@/api/taskClock';
import { formatDateTime } from '@/filters';
export default {
  components: { tableList, Dialog },
  data() {
    const taskStatus = [
      { id: 0, value: '已发布', color: 'success' },
      { id: 1, value: '草稿', color: 'warning' },
      { id: 2, value: '已结束' },
      { id: 3, value: '报名截止' },
      { id: 4, value: '开放报名中' },
      { id: 5, value: '未开奖' },
      { id: 6, value: '已开奖' },
      { id: 7, value: '已公示' },
      // 0已发布，1未发布，2已结束，3已截止报名,4可报名,5未开奖,6已开奖,7已公示
    ];
    return {
      taskStatus,
      selectionId: [],
      formDialogShow: false,
      importDialogShow: false,
      currentID: -1,
      information: {},
      lotteryRules: {
        giftsName: [
          { required: true, message: '请输入抽奖标题', trigger: 'blur' },
        ],
        gifts: [
          { required: true, message: "请输入礼品数", trigger: "blur" },
        ],
        exportTime: [
          { required: true, message: "请输入兑奖日期", trigger: "blur" },
        ],
      },
      lotteryForm: {},
      lotteryId: null,
      isRunALottery: false,
      exportTimes: {
        prizeBeginTime: "",
        prizeEndTime: "",
      },
    };
  },
  methods: {
    // 打卡记录下载
    downExportList(id) {
      taskClockExportList(id).then(res => {
        if (res) {
          this.$message.success('下载成功');
        }
      });
    },
    runALottery(row) {
      this.importDialogShow = true;
      this.lotteryForm = row;
    },
    searchResult(id) {
      const _this = this;
      this.$Api.taskClock.getTaskLotteryDownload({ objectType: 9, objectId: id }).then(res => {
        _this.$message.success('下载成功');
        _this.$refs['multipleTable'].getTableList();
      });
    },
    showResult(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'show',
        icon: 'warn',
        subTitle: `是否确认在小程序前端公示【${row.title}】活动开奖结果？`,
      };
    },
    uploadSubmit() {
      // 确认抽奖        打卡objectType为9
      const { id, taskCompleteNum } = this.lotteryForm;
      const _this = this;
      if (taskCompleteNum == '0') {
        return _this.$message.error('没有人完成挑战不可抽奖');
      }
      this.$Api.challengeMatch.lotteryUserLottery({ ..._this.exportTimes, objectType: 9, objectId: id }).then(res => {
        _this.$message.success('抽奖成功');
        _this.$refs['multipleTable'].getTableList();
      });
      this.handleCloseImport();
    },
    handleCloseImport() {
      this.importDialogShow = false;
      this.lotteryForm = {};
    },
    // 处理导出时间
    handleFormatExportTime(val) {
      this.exportTimes = {
        prizeBeginTime: "",
        prizeEndTime: "",
      };
      if (val && val.length) {
        this.exportTimes = {
          prizeBeginTime: formatDateTime(val[0]),
          prizeEndTime: formatDateTime(val[1]),
        };
      }
    },
    exportClassList() {
      this.$Api.course.getExportCourse().then(res => {
        this.$message.success('导出成功');
      });
    },
    copyLink(id) {
      navigator.clipboard.writeText(`/pages-activity/ua-task-clock/index?id=${id}`).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },
    add() {
      this.$router.push({ path: '/online_activity/taskClock/add' });
    },
    edit(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      if (row.status == 6 || row.status == 7) {
        this.isRunALottery = true;
      }
      this.information = {
        operation: 'edit',
        icon: 'warn',
        subTitle: `是否确认编辑任务ID为“${row.id}”的数据项？`,
      };
    },
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '删除后小程序用户将无法查看该打卡任务，请确认是否删除',
      };
    },
    submitSuccess(operation) {
      if (operation === 'delete') {
        this.$Api.taskClock.deleteTaskActivity([this.currentID], { hideMessage: true }).then(() => {
          this.formDialogShow = false;
          this.$message.success('删除成功');
          this.$refs['multipleTable'].getTableList();
        }).catch(error => {
          this.formDialogShow = true;
          this.information = {
            operation: 'error',
            icon: 'error',
            subTitle: `${error.errorMessage}`,
          };
        });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/online_activity/taskClock/edit', query: { id: this.currentID, lottery: this.isRunALottery } });
      } else if (operation === 'show') {
        this.$Api.taskClock.taskClockShowLottery(this.currentID).then(() => {
          this.formDialogShow = false;
          this.$refs['multipleTable'].getTableList();
        }).catch(error => {
          this.formDialogShow = true;
          this.information = {
            operation: 'error',
            icon: 'error',
            subTitle: `${error.errorMessage}`,
          };
        });
      }
    },
    // 上架
    postOnlineTask(id) {
      this.$Api.taskClock.publishTaskActivity([id]).then(() => {
        this.$message.success('上架成功');
        this.$refs['multipleTable'].getTableList();
      });
    },
    // 下架
    postOfflineTask(id) {
      this.$Api.taskClock.soldOutTaskActivity([id]).then(() => {
        this.$message.success('下架成功');
        this.$refs['multipleTable'].getTableList();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-tag {
  font-size: 14px;
  font-weight: 400;
}
.el-tag.el-tag--purple {
  background-color: rgba(114, 46, 209, 0.1);
  border-color: rgba(114, 46, 209, 0.7);
  color: #722ed1;
}
.el-tag.el-tag--blue {
  background-color: rgba(24, 144, 255, 0.1);
  border-color: rgba(24, 144, 255, 0.7);
  color: #1890ff;
}
.el-tag.el-tag--yellow {
  background-color: rgba(234, 153, 33, 0.1);
  border-color: rgba(234, 153, 33, 0.7);
  color: #ea9921;
}

.el-tag.el-tag--red {
  background-color: rgba(220, 0, 25, 0.1);
  border-color: rgba(220, 0, 25, 0.7);
  color: #dc0019;
}
.el-tag.el-tag--end {
  background-color: rgba(73, 73, 73, 0.1);
  border-color: rgba(155, 155, 155, 0.7);
  color: #9b9b9b;
}
.el-tag.el-tag--gray {
  background-color: rgba(73, 73, 73, 0.2);
  border-color: rgba(155, 155, 155, 0.7);
  color: #9b9b9b;
}
.el-dialog__wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .share-wrapper {
    width: 580px;
    margin: unset !important;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 30px;
      .upload-wrap {
        width: 100%;
        height: 236px;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        padding: 20px 30px;
        box-sizing: border-box;
        .el-upload-dragger {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .tips {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #494949;
          margin-bottom: 20px;
        }
        .upload-box {
          width: 100%;
          height: 156px;

          .el-upload.el-upload--text {
            width: 100%;
            height: 100%;
            .el-upload-dragger {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #bbbbbb;
              border-radius: 4px;
              &:hover {
                border-color: #1c1c1c;
              }
              .file {
                line-height: 20px;
                margin-top: 5.68px;
              }
              .el-button {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .btns {
      justify-content: center;
      margin-top: 30px;
      .el-button {
        width: 120px;
        height: 50px;
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
.submitBtn {
  width: 170px !important;
}

.lottery-form {
  .el-form-item {
    margin-bottom: 0;
  }
}

.lottery-top {
  width: 100%;
  height: 23px;
  display: flex;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  margin-bottom: 20px;
  div {
    margin-right: 50px;
  }
}

.lottery-time {
  width: 370px !important;
}

.prizeBox {
  position: relative;
  display: flex;
  width: 100%;

  :last-child {
    position: absolute;
    left: 0;
    margin-left: 170px;
  }
  .prizeName {
    max-width: 110px;
  }

  > span {
    display: inline-block;
    margin-bottom: 20px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #494949;
  }
}
</style>
